import Cookies from "js-cookie"
import { makeObservable } from "mobx"
import { AppGeolocation } from "../models/app/AppGeolocation"
import { IMChatMetadata } from "../models/app/IMChatMetadata"
import { LoggedInUser } from "../models/app/LoggedInUser"
import { ANONYMOUS } from "../models/constants"
import ApiService from "../services/ApiService"
import AppCrypto from "../services/CryptoService"
import DbService from "../services/DbService"
import { db } from "../services/DexieDbImpl"
import LocalStorageService from "../services/LocalStorageService"
import MqttService from "../services/MqttService"
import ChatStore from "./ChatStore"
import { RootStore } from "./RootStore"

export var chatStore = new ChatStore()

export default class MainStore {

    token: string | null = null
    userName: string = 'anonym'
    nameOfUser: string| null
    uid: string | null = null
    currentChatId!: string
    currentVChatterId!: string
    geoLocation: AppGeolocation | null = null
    currentImChatMeta: IMChatMetadata | null = null
    appFocus: boolean = false
    fcmToken: string | null
    blockList: string[] = []

    //currentImChatId!: string

    rootStore: RootStore

    constructor(rootStore: RootStore) {

        makeObservable(this, {
            uid: true
        })

        this.rootStore = rootStore

        var cookies = Cookies.get()

        this.token = Cookies.get('token') ?? null
        this.userName = Cookies.get('userName') ?? ANONYMOUS
        this.uid = Cookies.get('uid') ?? null

        let localLocation = LocalStorageService.getItem('geolocation')
        if (localLocation != null) {
            this.geoLocation = JSON.parse(localLocation)
        }
        let localChatMeta = LocalStorageService.getItem('currentImChatMeta')
        if (localChatMeta)
            this.currentImChatMeta = JSON.parse(localChatMeta)
        
        this.nameOfUser = LocalStorageService.getItem('name')

        this.fcmToken = LocalStorageService.getItem('fcm_token')

    }

    get currentImChatId() {
        return DbService.getCurrentImChatId()
    }

    set currentImChatId(chatId: string | null) {
        DbService.setCurrentImChatChatId(chatId)
    }

    get currentImChatUserId() {
        return DbService.getCurrentImChatUserId()
    }

    set currentImChatUserId(userId: string | null) {
        DbService.setCurrentImChatUserId(userId)
    }

    setToken(token: string) {
        this.token = token
    }

    setUserName(userName: string) {
        this.userName = userName
    }

    setUid(uid: string) {
        this.uid = uid
    }

    setCurrentChatId(chatId: string) {
        this.currentChatId = chatId
    }

    setCurrentImChatId(chatId: string) {
        this.currentImChatId = chatId
    }

    setCurrentImChatUserId(userId: string) {
        this.currentImChatUserId = userId
    }

    setCurrentVChatterId(data: string) {
        this.currentVChatterId = data
    }

    setCurrentImChatMeta(data: IMChatMetadata) {
        this.currentImChatMeta = data
        LocalStorageService.updateStorage('currentImChatMeta', data)
    }

    updateGeolocation(location: AppGeolocation) {
        this.geoLocation = location
        LocalStorageService.updateStorage('geolocation', JSON.stringify(location))
    }

    updateNameOfUser(data: string){
        LocalStorageService.updateStorage('name', data)
        this.nameOfUser = data
    }

    updateBlockList(data: string){
        this.blockList.push(data)
        LocalStorageService.updateStorage('blockList', this.blockList)
    }

    logoutUser() {
        ApiService.logout()
        MqttService.disconnect()
        this.token = null
        this.userName = 'anonym'
        this.uid = null
        Cookies.remove('token')
        Cookies.remove('userName')
        Cookies.remove('uid')
        chatStore = new ChatStore()
        AppCrypto.dumpKeys()
        this.geoLocation = null


        //Delete database
        db.destruct()
        LocalStorageService.clearAll()
        //this.rootStore = new RootStore()
    }

    setLoggedInUser(user: LoggedInUser) {
        this.userName = user.userId
        this.uid = user.uid
        this.token = user.token
        Cookies.set('token', user.token, { expires: 365 })
        Cookies.set('userName', this.userName, { expires: 365 })
        Cookies.set('uid', this.uid, { expires: 365 })
    }

}